import api from "@/api/axios";
export default {
  namespaced: true,
  state: {
    orders: null,
  },
  mutations: {
    SET_ORDERS(state, payload) {
      state.orders = payload;
    },
  },
  actions: {
    async getOrders({ commit }, payload) {
      try {
        commit("setLoading", true, { root: true });
        await api
          .get("/admin/orders", {
            params: payload,
          })
          .then((res) => {
            commit("SET_ORDERS", res.data);
          });
        commit("setLoading", false, { root: true });
      } catch (error) {
        commit("setLoading", false, { root: true });
        return error;
      }
    },
  },
};
